import { HELP, ARTICLE } from './apiModules'

const HELP_SETTING_PREFIX = `${HELP}/setting`
const HELP_ARTICLE_PREFIX = `${HELP}/${ARTICLE}`
const HELP_FILE_PREFIX = `${HELP}/file`
const HELP_CATEGORY_PREFIX = `${HELP}/category`
const HELP_RESOURCE_PREFIX = `${HELP}/resource`
import { get, post } from '@/utils/request'
export function getHomePageSetting() {
  return get(`${HELP_SETTING_PREFIX}/getHomePageSetting`)
}

export function getInsidePageSetting() {
  return get(`${HELP_SETTING_PREFIX}/getInsidePageSetting`)
}

export function getHelpArticleList(
  params = {
    exactMatchArr: [],
    page: 0,
    limit: 20
  }
) {
  return post(`${HELP_ARTICLE_PREFIX}/list`, params)
}

export function getHelpFileList(
  params = {
    exactMatchArr: [],
    page: 0,
    limit: 20
  }
) {
  return post(`${HELP_FILE_PREFIX}/list`, params)
}

export function getSearchList(
  params = {
    exactMatchArr: [],
    page: 0,
    limit: 20,
    searchKeyword: ''
  }
) {
  return post(`${HELP_ARTICLE_PREFIX}/search`, params)
}

export function getSearchSuggest(
  params = {
    searchKeyword: '',
    limit: ''
  }
) {
  return post(`${HELP_ARTICLE_PREFIX}/suggest`, params)
}

export function getCategoryByName(
  params = {
    name: ''
  }
) {
  return post(`${HELP_CATEGORY_PREFIX}/queryByName`, params)
}

export function getIndexCategory() {
  return get(`${HELP_CATEGORY_PREFIX}/homePaeRegularList`)
}

export function getCategory(
  params = {
    id: ''
  }
) {
  return post(`${HELP_CATEGORY_PREFIX}/hierarchicalList`, params)
}

export function reportClick(
  params = {
    resourceId: '',
    type: ''
  }
) {
  return post(`${HELP_RESOURCE_PREFIX}/click`, Object.assign(params, { from: 'WEB' }))
}

export function getBootomInfo() {
  return  get(`${HELP_CATEGORY_PREFIX}/bottomPaeRegularList`)
}
